var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 12'%3e%3cpath fill='%23006a4e' d='M0 0h20v12H0z'/%3e%3ccircle cx='9' cy='6' r='4' fill='%23f42a41'/%3e%3c/svg%3e";
  export default img;